import { useEffect, useState } from "react";
import Loading from "../Components/Loading";
import {
  Select,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {
  Button,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Modal,
} from "react-bootstrap";
import { Button as MaterialButton } from "@mui/material";

import * as api from "../api/api";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
import ReactSelect from "react-select";
import Option from "react-select";
import YesNoModal from "../Components/Modal/YesNoModal";
import { BiSearch } from "react-icons/bi";
import InputGroup from "react-bootstrap/InputGroup";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LastPageIcon from "@mui/icons-material/LastPage";
import { FaInfoCircle } from "react-icons/fa";
import { useDebounce } from "@uidotdev/usehooks";

export default function AdminUserRoles() {
  const { language } = useLanguage();
  const pageTitle = "AdminUserRoles";

  const [isLoading, setIsLoading] = useState(true);
  const [allUsers, setAllUsers] = useState();
  const [allRoles, setAllRoles] = useState();
  const [newUserInfo, setNewUserInfo] = useState({ role: 1 });
  const [showModal, setShowModal] = useState(false);
  const [snackbarData, setSnackbarData] = useState({});
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState({});
  const [allTenants, setAllTenants] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [numberOfItems, setNumberOfItems] = useState(0);
  const navigate = useNavigate();

  function getUsers(pageNo, userName) {
    let tenantId = selectedTenantId ?? 1;
    //console.log("Paulo passed here!");
    pageNo = pageNo ?? 1;
    api.getUsersOfTenant(tenantId, pageNo, 30, userName).then((response) => {
      // sort users by date of creation (soonest to furthest)
      const responseObj = response.data.object;
      setNumberOfPages(
        response.data.object.totalPages == 0
          ? 1
          : response.data.object.totalPages
      );
      setNumberOfItems(response.data.object.totalSize);

      setAllUsers(responseObj.userRoles);
      setSearchRunning(false);
    });
  }

  function getAllRoles() {
    setIsLoading(true);
    api.getAllRoles().then((response) => {
      console.log(response);
      setAllRoles(response.data.object);
      //setIsLoading(false);
    });
  }

  function deleteUserRole() {
    let { user, removedRoles } = userToDelete;

    removedRoles.forEach((role) => {
      api
        .unassignUserFromRole(user.user.username, role.roleId, selectedTenantId)
        .then((response) => {
          console.log(response);

          if (response.data.statusCode == 500) {
            setSnackbarData({
              ...snackbarData,
              message: response.data.message,
              show: true,
              severity: "error",
            });
            return;
          }

          getUsers(currentPage);
          setSnackbarData({
            ...snackbarData,
            message: strings[pageTitle][language].updateSuccessSnackbar,
            show: true,
            severity: "success",
          });
        })
        .catch((e) => {
          console.log(e);
          setSnackbarData({
            ...snackbarData,
            message: e.data.object.message,
            show: true,
            severity: "error",
          });
        });
      setIsLoading(false);
      setUserToDelete({});
    });
  }

  function handleChange(user, addedRoles, removedRoles, noOfRoles) {
    setIsLoading(true);

    console.log(user, addedRoles, removedRoles);

    console.log(allUsers);

    // match these roles with the "allRoles" var
    setAllUsers((prevUsers) =>
      prevUsers.map((u) =>
        u.user.userId === user.user.userId
          ? {
              ...u,
              roles: [
                ...u.roles.filter(
                  (existingRole) =>
                    !removedRoles.some(
                      (removedRole) =>
                        removedRole.roleId === existingRole.roleId
                    )
                ),
                ...addedRoles.map((addedRole) => {
                  // Find the corresponding role from allRoles based on roleId
                  return allRoles.find(
                    (role) => role.roleId === addedRole.value
                  );
                }),
              ],
            }
          : u
      )
    );

    addedRoles.forEach((role) => {
      // api calls to add the roles
      let payload = {
        username: user.user.username,
        tenantId: user.user.tenantId ?? selectedTenantId,
        roleId: role.value,
      };

      api
        .assignUserToTenant(payload)
        .then((response) => {
          console.log(response);
          //getUsers(currentPage);
          setSnackbarData({
            ...snackbarData,
            message: strings[pageTitle][language].updateSuccessSnackbar,
            show: true,
            severity: "success",
          });
        })
        .catch((e) => {
          console.log(e);
          setSnackbarData({
            ...snackbarData,
            message: e.data.object.message,
            show: true,
            severity: "error",
          });
        });
      setIsLoading(false);
    });

    removedRoles.forEach((role) => {
      api
        .unassignUserFromRole(user.user.username, role.roleId, selectedTenantId)
        .then((response) => {
          console.log(response);
          //getUsers(currentPage);
          setSnackbarData({
            ...snackbarData,
            message: strings[pageTitle][language].updateSuccessSnackbar,
            show: true,
            severity: "success",
          });
        })
        .catch((e) => {
          console.log(e);
          setSnackbarData({
            ...snackbarData,
            message: e.data.object.message,
            show: true,
            severity: "error",
          });
        });
      setIsLoading(false);
    });
    // let roleIds = value;
    // let newRoles;
    // try {
    //   newRoles = roleIds.map((newRole) => {
    //     return allRoles.filter((roles) => {
    //       return roles.roleId === newRole;
    //     })[0];
    //   });
    // } catch (e) {
    //   newRoles = allRoles.filter((roles) => {
    //     return roles.roleId === roleIds;
    //   })[0];
    // }
    // console.log(newRoles);

    // setAllUsers((prevUsers) =>
    //   prevUsers.map((u) =>
    //     u.user.userId === user.user.userId ? { ...u, role: newRoles } : u
    //   )
    // );

    // const foundUser = allUsers.find(
    //   (userInternal) => userInternal.user.userId === user.user.userId
    // );
    // console.log(foundUser);
    // console.log(newRoles);
    // let newRoleNames;
    // try {
    //   newRoleNames = newRoles.map((role) => {
    //     return role.name;
    //   });
    // } catch {
    //   newRoleNames = newRoles.name;
    // }
    // console.log(newRoleNames);

    // let payload = {
    //   username: foundUser.user.username,
    //   roleName: newRoleNames,
    //   tenantId: user.tenantId,
    // };
    /*
    console.log(payload);
    api
      .assignRoleToUser(payload)
      .then((response) => {
        console.log(response);
        getUsers();
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].updateSuccessSnackbar,
          show: true,
          severity: "success",
        });
      })
      .catch((e) => {
        console.log(e);
        setSnackbarData({
          ...snackbarData,
          message: e.data.object.message,
          show: true,
          severity: "error",
        });
      });*/
    setIsLoading(false);
  }

  function handleNewUserInfoChange(param, event) {
    setNewUserInfo({ ...newUserInfo, [param]: event.target.value });
  }

  function addNewUser(event) {
    setIsLoading(true);
    event.preventDefault();

    console.log(newUserInfo);
    let foundRole = allRoles.filter((role) => role.roleId == newUserInfo.role);
    console.log(foundRole[0]);
    newUserInfo.roleId = foundRole[0].roleId;
    newUserInfo.tenantId = selectedTenantId;
    delete newUserInfo.role;
    console.log(newUserInfo);

    api
      .createNewUser(newUserInfo)
      .then((response) => {
        console.log(response);

        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].addSuccessSnackbar,
          show: true,
          severity: "success",
        });

        if (response.data.statusCode == 400) {
          setSnackbarData({
            ...snackbarData,
            message: strings[pageTitle][language].duplicateEmailSnackbar,
            show: true,
            severity: "error",
          });
        }

        getUsers(1);
        setNewUserInfo({ role: 1 });
      })
      .catch((e) => {
        console.log(e);
      });

    setShowModal(false);

    setIsLoading(false);
  }

  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const delay = 500; // Adjust the delay as needed (in milliseconds)
  const [searchRunning, setSearchRunning] = useState(false);
  const searchValue = useDebounce(inputValue, delay);

  useEffect(() => {
    setIsTyping(false);
    setSearchRunning(true);
    console.log("Stopped typing:", searchValue);
    // You can perform any action when the user stops typing here
    // make the api call now
    if (searchValue.length < 3) {
      // if clearing the field, run the api request, else do not run
      if (searchValue.length === 0) {
        getUsers(null, "");
      } else {
        setSearchRunning(false);
      }
    } else {
      setCurrentPage(1);
      getUsers(null, searchValue);
    }
  }, [searchValue]);

  const handleInputChange = (event) => {
    setInputValue(event);
  };

  useEffect(() => {
    setIsLoading(true);
    checkAuthorization("USER_ROLES").then((result) => {
      if (result) {
        getUsers();
        getAllRoles();
        api.getAllActiveTenants().then((response) => {
          //console.log(response.data.object, response.data.object.filter((item) => item.isActive));
          setAllTenants(response.data.object.filter((item) => item.isActive));
          setIsLoading(false);
        });
      } else {
        navigate("/unauthorized");
      }
    });
    //getUsers();
  }, []);

  const [selectedTenantId, setSelectedTenantId] = useState(
    JSON.parse(sessionStorage.getItem("userTenant"))?.tenantId || 1
  );
  useEffect(() => {
    getUsers(1, inputValue);
  }, [selectedTenantId]); // Dependency array ensures the effect runs when yourState changes

  return isLoading ? (
    <Loading></Loading>
  ) : (
    <div className="main-content-container">
      <div className="main-content">
        <div>
          <YesNoModal
            propShow={showConfirmDeleteModal}
            YesText={strings[pageTitle][language].delete}
            NoText={strings[pageTitle][language].cancel}
            handleShowModal={setShowConfirmDeleteModal}
            handleYes={() => deleteUserRole()}
            title={strings[pageTitle][language].confirmDelete}
            children={[strings[pageTitle][language].confirmDeleteBody]}
          />
          <div className="main-content__title d-flex align-items-center justify-content-between">
            <h6 className="">{strings[pageTitle][language].pageName}</h6>
            <div className="d-flex align-items-end gap-2 ">
              {true && (
                <>
                  <h6>Selected Tenant: </h6>
                  <FormControl>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      value={parseInt(selectedTenantId) || selectedTenantId}
                      input={<OutlinedInput label="Name" />}
                      sx={{ width: 150, height: 40 }}
                      onChange={(event) => {
                        setSelectedTenantId(event.target.value);
                        console.log(event.target.value);
                      }}
                    >
                      {allTenants.map((item) => (
                        <MenuItem key={item.tenantId} value={item.tenantId}>
                          {" "}
                          {item.name}{" "}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </>
              )}
              <Button
                variant="outline-primary"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                {strings[pageTitle][language].add}
              </Button>
            </div>
          </div>
        </div>
        <hr className="main-content-title__hr" />
        <div className="form-group row" style={{ margin: "0 1.5em 0 1.5em " }}>
          <InputGroup className="mb-3">
            <Form.Control
              placeholder={strings[pageTitle][language].searchPlaceholder}
              aria-label="Search"
              aria-describedby="basic-addon2"
              onChange={(event) => {
                console.log(event.target.value);

                handleInputChange(event.target.value);
              }}
            />
            <InputGroup.Text id="basic-addon2">
              <BiSearch />
            </InputGroup.Text>
            <InputGroup.Text>
              <FaInfoCircle title={strings[pageTitle][language].searchHint} />
            </InputGroup.Text>
          </InputGroup>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackbarData.show}
          autoHideDuration={3000}
          onClose={() => setSnackbarData({ ...snackbarData, show: false })}
        >
          <Alert severity={snackbarData.severity}>{snackbarData.message}</Alert>
        </Snackbar>
        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
        >
          <Form onSubmit={addNewUser}>
            <ModalHeader>
              {strings[pageTitle][language].addModalHeader}
            </ModalHeader>
            <ModalBody>
              <Form.Group className="mb-3">
                <Form.Label>
                  {strings[pageTitle][language].modalLabels[0]}
                </Form.Label>
                <Form.Control
                  placeholder=""
                  onChange={(event) => {
                    handleNewUserInfoChange("username", event);
                  }}
                  required
                  type="email"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  {strings[pageTitle][language].modalLabels[1]}
                </Form.Label>
                <Form.Control
                  placeholder=""
                  onChange={(event) => {
                    handleNewUserInfoChange("name", event);
                  }}
                  required
                  type="text"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  {strings[pageTitle][language].modalLabels[2]}
                </Form.Label>
                <Form.Select
                  onChange={(event) => {
                    handleNewUserInfoChange("role", event);
                  }}
                >
                  {allRoles?.map((role) => {
                    return (
                      <option value={role.roleId} key={role.roleId}>
                        {role.name}
                      </option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="outline-danger"
                onClick={() => setShowModal(false)}
              >
                {strings[pageTitle][language].cancel}
              </Button>
              <Button
                variant="outline-primary"
                className="outline-button"
                type="submit"
              >
                {strings[pageTitle][language].add}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        {searchRunning ? (
          <Loading />
        ) : (
          <table
            style={{ boxSizing: "content-box", margin: "0 2em 0 2em" }}
            className="activity-table"
          >
            <thead>
              <tr>
                <th>{strings[pageTitle][language].tableHeaders[0]}</th>
                <th>{strings[pageTitle][language].tableHeaders[1]}</th>
                <th>{strings[pageTitle][language].tableHeaders[2]}</th>
              </tr>
            </thead>
            <tbody>
              {allUsers.map((user) => {
                return (
                  <tr key={user.user.userId}>
                    <td style={{ width: "15.33%" }}>{user.user.name}</td>
                    <td style={{ width: "15.33%" }}>{user.user.username}</td>
                    <td style={{ width: "33.33%" }}>
                      <ReactSelect
                        isMulti
                        style={{ border: "none" }}
                        value={
                          user.roles.length !== 0
                            ? user.roles.map((role) => ({
                                value: role.roleId,
                                label: role.name,
                              }))
                            : null
                        }
                        //onMenuClose={}
                        onChange={(value) => {
                          const addedRoles = value.filter(
                            (role) =>
                              !user.roles.some(
                                (userRole) => userRole.roleId === role.value
                              )
                          );
                          const removedRoles = user.roles.filter(
                            (userRole) =>
                              !value.some(
                                (role) => role.value === userRole.roleId
                              )
                          );

                          console.log("Added Roles:", addedRoles);
                          console.log("Removed Roles:", removedRoles);
                          console.log(value.length);

                          if (value.length == 0) {
                            // this is the case where the user is deleted
                            setShowConfirmDeleteModal(true);
                            setUserToDelete({
                              user: user,
                              removedRoles: removedRoles,
                            });
                          } else {
                            handleChange(
                              user,
                              addedRoles,
                              removedRoles,
                              value.length
                            );
                          }
                        }}
                        options={allRoles?.map((role) => {
                          return { value: role.roleId, label: role.name };
                        })}
                      ></ReactSelect>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        <nav className="pagination-container">
          <ul className="pagination">
            <li>
              <MaterialButton
                onClick={() => {
                  // pressed first button
                  getUsers(1);
                  setCurrentPage(1);
                }}
                disabled={currentPage == 1 || currentPage == 0}
              >
                <FirstPageIcon></FirstPageIcon>{" "}
                {strings[pageTitle][language].first}
              </MaterialButton>
            </li>
            <li>
              <MaterialButton
                onClick={() => {
                  //pressed prev
                  getUsers(currentPage - 1);
                  setCurrentPage(currentPage - 1);
                }}
                disabled={currentPage == 1 || currentPage == 0}
              >
                <ArrowBackIosIcon></ArrowBackIosIcon>{" "}
                {strings[pageTitle][language].previous}
              </MaterialButton>
            </li>
          </ul>

          <p>
            {strings[pageTitle][language].page} {currentPage}{" "}
            {strings[pageTitle][language].of} {numberOfPages} ({numberOfItems}{" "}
            {strings[pageTitle][language].items})
          </p>
          <ul className="pagination">
            <li>
              <MaterialButton
                onClick={() => {
                  //pressed next
                  getUsers(currentPage + 1);
                  setCurrentPage(currentPage + 1);
                }}
                disabled={currentPage === numberOfPages}
              >
                {strings[pageTitle][language].next}{" "}
                <ArrowForwardIosIcon></ArrowForwardIosIcon>
              </MaterialButton>
            </li>
            <li>
              <MaterialButton
                onClick={() => {
                  //pressed last
                  getUsers(numberOfPages);
                  setCurrentPage(numberOfPages);
                }}
                disabled={currentPage == numberOfPages}
              >
                {strings[pageTitle][language].last}
                <LastPageIcon></LastPageIcon>
              </MaterialButton>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
